
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#71798A","d":"M21.6 5.4v10.7a2.6 2.6 0 01-2.6 2.6H5a2.6 2.6 0 01-2.6-2.6V5.4h19.2zm-1.935 4.772l-.18.088L12 13.646 4.516 10.26a3.59 3.59 0 01-.916-.597V16.1a1.4 1.4 0 001.265 1.394L5 17.5h14a1.4 1.4 0 001.4-1.4l.001-6.437a3.55 3.55 0 01-.736.51zm.735-3.573H3.6v.38c0 .885.485 1.691 1.253 2.11l.158.077L12 12.33l6.99-3.163a2.399 2.399 0 001.404-2.01l.006-.176V6.6z","fill-rule":"evenodd"}})])
          )
        }
      }
    